import { EditableComponent } from '@adobe/aem-react-editable-components';

import { PrivacyRightsMainContainer } from './PrivacyRightsMainContainer';
import { GlobalStyles } from './PrivacyRightsWrapper.styles';

export const PrivacyRightsWrapperConfig = {
  emptyLabel: 'PrivacyRightsWrapperV2',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/cpraccpawrapper`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PrivacyRightsWrapperV2 = (props: any) => {
  const { model: privacyRightsAemModelData } = props;
  return (
    <EditableComponent config={PrivacyRightsWrapperConfig} {...props}>
      <GlobalStyles />
      <PrivacyRightsMainContainer privacyRightsAemModelData={privacyRightsAemModelData} />
    </EditableComponent>
  );
};
